import { Layout } from "antd";
import SideMenu from "./SideMenu";
import { useLocation } from "react-router-dom";
//   import { sidebarItems } from "../utils/Sidebars";
const { Sider } = Layout;

export default function Sidebar(props) {
  const location = useLocation();
  const { show, setshow } = props.state;

  return (
    <>
      {location.pathname !== "/login" &&
        !location.pathname.includes("public") && (
          <Sider
            trigger={null}
            breakpoint="xs"
            onBreakpoint={(broken) => {
              setshow(broken);
            }}
            width="240px"
            style={{
              overflow: "auto",
              position: "fixed",
              zIndex: 1,
              left: 0,
              bottom: 0,
              top: 0,
              backgroundColor: "white",
              fontWeight: "bold",
              borderRight: "1px solid rgba(0,0,0,.1)",
              width: "240px",
            }}
            collapsedWidth="0"
            collapsed={show}
          >
            <SideMenu />
          </Sider>
        )}
    </>
  );
}
